const L = {
  name: "StackOverflow",
  dimensions: { width: 34, height: 41 },
  content: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M28.681 25.8174H32.2661V40.0329H0V25.8174H3.58513V36.479H28.681V25.8174Z" fill="currentColor"/>
    <path d="M7.49238 24.7614L25.1002 28.43L25.8404 24.9407L8.23255 21.2705L7.49238 24.7614ZM9.82239 16.4036L26.1334 23.934L27.6529 20.7003L11.3415 13.1699L9.82239 16.4036ZM14.3357 8.47102L28.1639 19.8858L30.4669 17.1444L16.6387 5.73L14.3357 8.47102ZM23.2617 0.0334473L20.3741 2.16255L31.1125 16.475L34.0002 14.3462L23.2617 0.0334473ZM7.17041 32.9256H25.096V29.3718H7.17041V32.9256Z" fill="currentColor"/>
    `
};
export {
  L as StackOverflow
};
